import { communitySocialMarkup } from './communityMarkup';
import { githubTrendingSocialMarkup } from './githubTrendingMarkup';

/**
 * Social view (mobile-only entry): a top-level `.view#view-social` that
 * hosts two sub-panels — Community (default) and GitHub Trending —
 * switched via sub-tabs.
 *
 * The sub-panels stay under `.social-panel` wrappers WITHOUT redundant
 * top-level view ids. GitHub Trending additionally renders a named Social
 * component instance: its DOM ids are unique and its runtime bindings use
 * mount-local `data-gh-role` selectors.
 *
 * The social view is reachable from:
 * - Mobile bottom tab bar ("Social" tab) → showSocial(...)
 * - Deep links: /social, /social/community, /social/github
 *
 * PC top-nav reaches the dedicated per-feature views directly:
 * - "Community" → showView('community') → #view-community
 * - "GitHub Trending" → showView('github-trending') → #view-github-trending
 */
export const socialMarkup = String.raw`<!-- ====== SOCIAL VIEW (Community + GitHub Trending) ====== -->
    <div class="view" id="view-social">
      <div class="social-header">
        <h1 class="social-title">Social</h1>
        <div class="social-sub-tabs" id="socialSubTabs">
          <button class="social-sub-tab active" data-sub="community" data-proto-click="setSocialSubTab('community')">Community</button>
          <button class="social-sub-tab" data-sub="github" data-proto-click="setSocialSubTab('github')">GitHub Trending</button>
        </div>
      </div>
      <div class="social-body">
        <div class="social-panel active" data-sub-panel="community">
          ${communitySocialMarkup}
        </div>
        <div class="social-panel" data-sub-panel="github">
          ${githubTrendingSocialMarkup}
        </div>
      </div>
    </div>
`;
